module.exports = __webpack_public_path__ + "static/WORLD0-1011e1fb9515c232592f90f997ae711e.jpg";